module.exports = __webpack_public_path__ + "assets/images/school.gif?v=e85a1539";